module.exports = __webpack_public_path__ + "img/beian_icon.0c577066.d0289dc0.png";